// import React, { createContext, useContext, useEffect, useState, useMemo  } from "react";
// import authApiService from "../services/authServices";
// import { jwtDecode } from "jwt-decode";

// const MessageContext = createContext();
// export const MessageProvider = ({ children }) => {
//     const [messages, setMessages] = useState([]);

   

//     const fetchMessages = async () => {
        
//         try {
//             const token = localStorage.getItem("accessToken"); 
//             let role = null;

//             if (token) {
//                 const decodedToken = jwtDecode(token); 
//                 role = decodedToken?.role;
//             }

//             const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
//             const cityId = selectedCity?.id;

//             let endpoint = "getPublicMessage";
//             let params = { cityId: cityId };

//             if (role === 2) {
//                 endpoint = "getPrivateMessage";
//                 params = { };
//             }
            
//             const response = await authApiService.get(endpoint, params);
//             setMessages(response.data || []);
//         } catch (error) {
//             console.error("Error fetching messages:", error);
//         }
//     };

//     useEffect(() => {
//         fetchMessages();
//     }, []);

//     // useMemo(() => {
//     //     fetchMessages();
//     // }, []);

//     return (
//         <MessageContext.Provider value={{ messages, fetchMessages  }}>
//             {children}
//         </MessageContext.Provider>
//     );
// };

// // Custom hook to use the context
// export const useMessages = () => useContext(MessageContext);




import React, { createContext, useContext, useEffect, useState, useRef, useCallback } from "react";
import authApiService from "../services/authServices";
import { jwtDecode } from "jwt-decode";

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
    const [messages, setMessages] = useState([]);
    const [privateMessages, setPrivateMessages] = useState([]);
    const [role, setRole] = useState(null);
    
    // API call ko track karne ke liye refs
    const isPublicFetching = useRef(false);
    const isPrivateFetching = useRef(false);

    useEffect(() => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            const decodedToken = jwtDecode(token);
            setRole(decodedToken?.role);
        }
    }, []);

    const fetchPublicMessages = useCallback(async () => {
        if (isPublicFetching.current) {
            return;
        }

        try {
            isPublicFetching.current = true;
            const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
            const cityId = selectedCity?.id;
            const params = cityId ? { cityId } : {};
            const response = await authApiService.get("getPublicMessage", params);
            setMessages(response.data || []);
        } catch (error) {
            console.error("Error fetching public messages:", error);
            setMessages([]);
        } finally {
            isPublicFetching.current = false;
        }
    }, []);

    const fetchPrivateMessages = useCallback(async (profileUserId = null) => {
        if (isPrivateFetching.current) {
            return;
        }

        const token = localStorage.getItem("accessToken");
        if (!token && !profileUserId) {
            setPrivateMessages([]);
            return;
        }

        try {
            isPrivateFetching.current = true;
            const params = profileUserId ? { userId: profileUserId } : {};
            const response = await authApiService.get("getPrivateMessage", params);
            setPrivateMessages(response.data || []);
        } catch (error) {
            console.error("Error fetching private messages:", error);
            setPrivateMessages([]);
        } finally {
            isPrivateFetching.current = false;
        }
    }, []);

    const fetchMessagesForHome = useCallback(async () => {
        await fetchPublicMessages();
    }, [fetchPublicMessages]);

    const fetchMessagesForProfile = useCallback(async (profileUserId = null, options = {}) => {
        const { includePrivate = true } = options;
        await fetchPublicMessages();
        if (includePrivate) {
            await fetchPrivateMessages(profileUserId);
        } else {
            setPrivateMessages([]);
        }
    }, [fetchPublicMessages, fetchPrivateMessages]);

    return (
        <MessageContext.Provider value={{ messages, privateMessages, fetchMessagesForHome, fetchMessagesForProfile }}>
            {children}
        </MessageContext.Provider>
    );
};

// Custom hook to use the context
export const useMessages = () => useContext(MessageContext);

